import { useMemo } from 'react';
import { TH, MP, REWARDS_CATALOG } from '../lib/constants.js';
import { YR } from '../lib/dateState.js';
import { Back } from '../components/Basic.jsx';
import { Bookshelf } from '../components/Shelf.jsx';
import { t as tr } from '../lib/i18n.js';
export function ShelfEditorView({t,st,dispatch,go}){
  const pt=TH[st.myTheme]||TH.neon;
  // Stessa costruzione dello scaffale usata nel profilo vero, ma solo per
  // il proprio scaffale — modificare quello di qualcun altro non ha senso.
  const shelfItems=useMemo(()=>{
    const annualItems=Object.entries(st.books).map(([y,b])=>{
      const bt=TH[st.myTheme]||pt;
      return {key:`annual-${y}`,kind:"annual",year:parseInt(y),filled:b.pages?.length||0,max:365,
        spineBg:bt.pill,accent:bt.ac,emoji:bt.emoji,isActive:parseInt(y)===YR,leanSeed:((parseInt(y)*7)%5)-2};
    });
    const microItems=(st.micro||[]).map(m=>{
      const preset=MP.find(p=>p.id===m.preset)||MP[0];
      const bt=TH[m.theme]||TH.neon;
      return {key:`micro-${m.id}`,kind:"micro",microId:m.id,title:m.title,filled:m.pages,max:m.max||20,
        spineBg:bt.pill,accent:bt.ac,emoji:m.cover||preset.icon,isActive:false,
        leanSeed:((String(m.id).length*11+(typeof m.id==="number"?m.id%7:0)))%5-2};
    });
    const sharedItems=(st.sharedBooks||[]).map(sb=>{
      const preset=MP.find(p=>p.id===sb.preset)||MP[0];
      const bt=TH[sb.theme]||TH.neon;
      return {key:`shared-${sb.id}`,kind:"shared",sharedId:sb.id,title:sb.title,filled:sb.pages,max:sb.max||20,
        spineBg:bt.pill,accent:bt.ac,emoji:sb.cover||preset.icon,isActive:false,
        badge:sb.kind==="family"?"👨‍👩‍👧‍👦":"🤝",
        leanSeed:((String(sb.id).length*13+7))%5-2};
    });
    return [...annualItems,...microItems,...sharedItems];
  },[st.books,st.micro,st.sharedBooks,pt,st.myTheme]);
  const orderedShelfKeys=(st.shelfOrder&&st.shelfOrder.length)
    ? [...st.shelfOrder.filter(k=>shelfItems.some(i=>i.key===k)),...shelfItems.filter(i=>!st.shelfOrder.includes(i.key)).map(i=>i.key)]
    : shelfItems.map(i=>i.key);
  const shelfItemsOrdered=orderedShelfKeys.map(k=>shelfItems.find(i=>i.key===k)).filter(Boolean);
  const unlockedDecor=st.rewards.unlocked.map(id=>REWARDS_CATALOG.find(r=>r.id===id)).filter(r=>r&&(r.type==="badge"||r.type==="divider"));
  const equippedIds=st.rewards.equippedDecorations||[];
  const equippedDecorations=equippedIds.map(id=>{
    const r=REWARDS_CATALOG.find(x=>x.id===id);
    return r?{id,emoji:r.emoji,name:r.name}:null;
  }).filter(Boolean);
  const toggleEquip=(id)=>{
    const next=equippedIds.includes(id)?equippedIds.filter(x=>x!==id):[...equippedIds,id];
    dispatch({type:"SET_REWARDS",rewards:{...st.rewards,equippedDecorations:next}});
  };
  return(
    <div className="screen fade" style={{background:pt.bg,display:"flex",flexDirection:"column"}}>
      <div style={{padding:"14px 14px 11px",display:"flex",alignItems:"center",gap:11,borderBottom:`1px solid ${pt.ac}18`,flexShrink:0}}>
        <Back fn={()=>go("settings")} t={pt}/>
        <span style={{fontSize:17,fontWeight:800,color:pt.tx,fontFamily:"Inter,sans-serif",flex:1}}>{tr("shelf_header_title")}</span>
      </div>
      <div style={{padding:"13px 14px",flex:1,overflowY:"auto"}}>
        <div style={{fontSize:12,color:pt.soft,fontFamily:"Inter,sans-serif",lineHeight:1.55,marginBottom:16}}>
          {tr("shelf_instructions")}
        </div>
        <Bookshelf items={shelfItemsOrdered} dividers={st.rewards&&st.rewards.dividers} editable={true} layoutEditMode={true}
          onReorder={(order)=>dispatch({type:"SET_SHELF_ORDER",order})}
          decorations={equippedDecorations}
          decorationPositions={st.rewards.decorationPositions||{}}
          onDecorationMove={(id,x,y)=>{
            const nextPositions={...(st.rewards.decorationPositions||{}),[id]:{x,y}};
            dispatch({type:"SET_REWARDS",rewards:{...st.rewards,decorationPositions:nextPositions}});
          }}
        />
        {unlockedDecor.length===0?(
          <div style={{textAlign:"center",padding:"30px 20px",color:pt.soft,fontFamily:"Inter,sans-serif",fontSize:12.5}}>{tr("shelf_empty_decor")}</div>
        ):(
          <>
            <div style={{fontSize:10,fontWeight:700,color:pt.soft,fontFamily:"Inter,sans-serif",letterSpacing:"1.5px",textTransform:"uppercase",margin:"22px 0 10px"}}>{tr("shelf_decor_section_title")}</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:9}}>
              {unlockedDecor.map(r=>{
                const equipped=equippedIds.includes(r.id);
                return(
                  <div key={r.id} onClick={()=>toggleEquip(r.id)} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:5,cursor:"pointer",width:60}}>
                    <div style={{width:42,height:42,borderRadius:12,background:equipped?"rgba(255,215,0,.18)":pt.card,border:equipped?"1.5px solid #FFD700":`1px solid ${pt.bord}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:20}}>{r.emoji}</div>
                    <div style={{fontSize:8.5,fontFamily:"Inter,sans-serif",textAlign:"center",color:equipped?"#FFD700":pt.soft,fontWeight:equipped?700:400,lineHeight:1.2}}>{equipped?tr("shelf_decor_equipped"):tr("shelf_decor_tap_to_add")}</div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
